const getters = {
  algorithmPlatforms: (state) => state.enumList.algorithmPlatforms,
  algorithmTypes: (state) => state.enumList.algorithmTypes,
  faceAgeOptions: (state) => state.enumList.faceAgeOptions,
  faceEmotionOptions: (state) => state.enumList.faceEmotionOptions,
  bodyAttributeOptions: (state) => state.enumList.bodyAttributeOptions,
  algorithmMetricsOptions: (state) => state.enumList.algorithmMetricsOptions,
  bodyDriverOptions: (state) => state.enumList.bodyDriverOptions,
  faceMaskOptions: (state) => state.enumList.faceMaskOptions,
  bodyhelmetOptions: (state) => state.enumList.bodyhelmetOptions,
  detectionFireOptions: (state) => state.enumList.detectionFireOptions,
  bodyHeadShoulderOptions: (state) => state.enumList.bodyHeadShoulderOptions,
  bodyGestureOptions: (state) => state.enumList.bodyGestureOptions,
  bodyDetectionSmokingOptions: (state) =>
    state.enumList.bodyDetectionSmokingOptions,
  bodyReflectiveVestDetectionOptions: (state) =>
    state.enumList.bodyReflectiveVestDetectionOptions,
  classificationAnimalOptions: (state) =>
    state.enumList.classificationAnimalOptions,
  classificationDishesOptions: (state) =>
    state.enumList.classificationDishesOptions,
  classificationGeneralOptions: (state) =>
    state.enumList.classificationGeneralOptions,
  classificationVegetablesOptions: (state) =>
    state.enumList.classificationVegetablesOptions,
  classificationVehicleTypeOptions: (state) =>
    state.enumList.classificationVehicleTypeOptions,
  algorithmList: (state) => state.enumList.algorithmList,
  algorithmTypeList: (state) => state.enumList.algorithmTypeList,
  uuid: (state) => state.toolEnum.uuid,
  aideBuiltinModel: (state) => state.enumList.aideBuiltinModel,
  aideInformation: (state) => state.enumList.aideInformation,
}

export default getters
